module.exports = __webpack_public_path__ + "img/soldOut.14b6a96b.png";